import * as React from "react";
import * as Coin from "src/assets/coin.svg";
import { MoneyMask } from "src/util/Masks/MoneyMask";
import { Link } from "react-router-dom";
import ITradesPoints from "src/services/interfaces/ITradesPoints";

export enum StepTypes {
  NONE = "Nenhum nível atingido",
  FIRST = "Você já atingiu o nível 1",
  SECOND = "Você já atingiu o nível 2",
  THIRD = "Você já atingiu o nível 3",
  FOURTH = "Você já atingiu o nível 4"
}

export default function LevelStatus(props: ITradesPoints) {
  const currentStep =
    props.points === 0
      ? StepTypes.NONE
      : props.points < 3
      ? StepTypes.FIRST
      : props.points >= 3 && props.points < 6
      ? StepTypes.SECOND
      : props.points >= 6 && props.points < 10
      ? StepTypes.THIRD
      : StepTypes.FOURTH;
  return (
    <div className="card level-status-card">
      <div className="card-container">
        <div className="card-header">
          <img src={Coin} height="50px" />
        </div>
        {props.points > 0 ? (
          <div className="card-content">
            <h3>{props.points} Precatórios</h3>
            <span>{currentStep}</span>
            <span className="price">{MoneyMask(props.sumOperationsPrice)}</span>
            <Link to={"/gerencial/operacoes"}>Ver nergociações</Link>
          </div>
        ) : (
          <div className="card-content">
            <h3>Nenhuma operação</h3>
            <span>{currentStep}</span>
            <Link to={"/gerencial/operacoes"}>Ver nergociações</Link>
          </div>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/welcome/black-december/LevelStatus.tsx